import React, {useContext, useEffect, useState} from "react";
import {FormattedMessage, useIntl} from "react-intl";
import {Badge, Space, Switch, Table, Tag} from "antd";
import {ColumnsType} from "antd/es/table";
import {ICIPAdminActionTypeEnum, ICIPAdminDispatchContext} from "../../../../../context/ICIPAdminContext";
import {Box, CircularProgress, makeStyles} from "@material-ui/core";
import BusinessService from "../../../../../services/BusinessService";
import WithdrawRequest from "../../../../../models/WithdrawRequest";
import CurrencyFormat from "react-currency-format";
import { displayWalletType } from "../../../../../settings/WalletType";

interface WithdrawRequestsProps {
    businessId: number
}

const useStyles = makeStyles(() => ({
    confirmed : {
        color : "green",
      },
    
      unconfirmed : {
        color : "red"
      },
  }));

export const WithdrawRequests = (props: WithdrawRequestsProps) => {
    
    const { businessId } = props;

    const classes = useStyles(props);

    const intl = useIntl();

    const [withdrawRequests, setWithdrawRequests] = useState((): Array<WithdrawRequest> => null);

    const fetchWithdrawRequests = (businessId) => {
        BusinessService.businessWithdrawRequestList(businessId).then((response) => {

            let results: Array<WithdrawRequest> = [];

            if (response.isSuccess && response.data.code === 100) {
                JSON.parse(JSON.stringify(response.data.data['withdrawRequests'])).forEach(
                    (item, index) => {
                        results.push(WithdrawRequest.fromJson(item));
                    }
                );
                setWithdrawRequests(results);
            } else {
                setWithdrawRequests([]);
            }
            dispatch({
                type: ICIPAdminActionTypeEnum.loaded,
            });
            setInProgress(false);
        });
    };

    interface DataType {
        id: number;
        wallet_type: number;
        amount: string;
        amount_currency: string;
        icip_commission_amount: string;
        icip_commission_currency: string;
        validation_date: string;
        created_at: Date;
    }

    const columns: ColumnsType<DataType> = [
        {
            title: intl.formatMessage({ id: "sharedScreen.number" }),
            dataIndex: 'id',
            align: 'center'
        },
        {
            title: intl.formatMessage({ id: "sharedScreen.date" }),
            dataIndex: 'created_at'
        },

        {
            title: intl.formatMessage({ id: "sharedScreen.walletType" }),
            dataIndex: 'wallet_type',
            align: 'center',
            render: (_, element)=> (
                <FormattedMessage
                        id={displayWalletType(element.wallet_type)}
                />
            ),
        },

        {
            title: intl.formatMessage({ id: "sharedScreen.amount" }),
            dataIndex: 'amount',
            align: 'right',
            render: (_, element)=> (
                <CurrencyFormat
                    value={element.amount}
                    prefix={element.amount_currency}
                    displayType="text"
                    thousandSeparator={true}
                    fixedDecimalScale={true}
                    decimalScale={2}
                />
            ),
        },

        {
            title: intl.formatMessage({ id: "sharedScreen.commission" }),
            dataIndex: 'icip_commission_amount',
            align: 'right',
            render: (_, element)=> (
                <CurrencyFormat
                    value={element.icip_commission_amount}
                    prefix={element.icip_commission_currency}
                    displayType="text"
                    thousandSeparator={true}
                    fixedDecimalScale={true}
                    decimalScale={2}
                />
            ),
        },

        {
            title: intl.formatMessage({ id: "sharedScreen.status" }),
            render: (_, status) => (
                status.validation_date !== null ?
                    <Tag className={classes.confirmed}>
                        {intl.formatMessage({ id: "sharedScreen.valided" })}
                    </Tag>
                    :
                    <Tag className={classes.unconfirmed}>
                        <FormattedMessage id="sharedScreen.unValided" />
                    </Tag>
            ),
            align: 'right'
        }
    ];

    // State
    const [inProgress, setInProgress] = useState(false);

    const dispatch = useContext(ICIPAdminDispatchContext);

    useEffect(() => {
        setInProgress(true);
        fetchWithdrawRequests(businessId);
    }, []);

    const renderLoaderWrapper = () => {
        return (
            <Box display="flex" alignContent="center" mt={4} ml={4}>
                <Box display="inline-block">
                    <CircularProgress color="secondary" size={22} thickness={2}/>
                </Box>
            </Box>
        );
    };


    const render = () => {
        // @ts-ignore
        return (
            <div>
                <Table columns={columns} dataSource={withdrawRequests}/>
            </div>
        );
    };

    return (
        <div>
            <div style={{marginBottom: 16}}>
                {inProgress ? renderLoaderWrapper() : render()}
            </div>
        </div>
    );
};
